import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

function SheEarnsMyContentWatchIncome() {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showSample, setShowSample] = useState(false);
  const [fromDate, setFromDate] = useState("2025-11-01");
  const [toDate, setToDate] = useState("2025-11-10");
  const [selectedContent, setSelectedContent] = useState("All");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };

  const dummyRecords = [
    { sn: 1, contentTitle: "My First Blog Post", date: "2025-11-01", views: 150, income: 15 },
    { sn: 2, contentTitle: "Cooking Recipe Video", date: "2025-11-02", views: 200, income: 20 },
    { sn: 3, contentTitle: "My First Blog Post", date: "2025-11-03", views: 180, income: 18 },
    { sn: 4, contentTitle: "DIY Home Decor Tips", date: "2025-11-04", views: 120, income: 12 },
    { sn: 5, contentTitle: "Cooking Recipe Video", date: "2025-11-05", views: 250, income: 25 },
    { sn: 6, contentTitle: "Fitness Routine Guide", date: "2025-11-06", views: 90, income: 9 },
    { sn: 7, contentTitle: "My First Blog Post", date: "2025-11-07", views: 160, income: 16 },
    { sn: 8, contentTitle: "DIY Home Decor Tips", date: "2025-11-08", views: 140, income: 14 },
    { sn: 9, contentTitle: "Fitness Routine Guide", date: "2025-11-09", views: 110, income: 11 },
    { sn: 10, contentTitle: "Cooking Recipe Video", date: "2025-11-10", views: 220, income: 22 },
  ];

  const contentTitles = ["All", ...new Set(dummyRecords.map(rec => rec.contentTitle))];

  const filteredRecords = dummyRecords.filter((rec) => {
    const recDate = new Date(rec.date);
    const filterFrom = new Date(fromDate);
    const filterTo = new Date(toDate);
    return (
      recDate >= filterFrom &&
      recDate <= filterTo &&
      (selectedContent === "All" || rec.contentTitle === selectedContent)
    );
  });

  const totalAmount = filteredRecords.reduce((sum, rec) => sum + rec.income, 0);
  const recordCount = filteredRecords.length;

  if (!showSample) {
    return (
      <div className="min-h-screen bg-black">
        <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-pink-100 font-sans">
          {/* Header */}
          <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
            <div className="flex flex-col">
              <div className="text-xl lg:text-2xl font-bold text-pink-400">💖 SheEarns Content</div>
              <div className="text-[10px] lg:text-lg text-yellow-200">
                My Content Income
              </div>
            </div>

            {/* Desktop user controls */}
            <div className="hidden md:flex items-center gap-3">
              {isLoggedIn ? (
                <>
                  <div className="text-xs text-left text-pink-300">{userName}</div>
                  <button
                    onClick={handleLogout}
                    className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                    title="Logout"
                  >
                    ⏻
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => navigate("/login")}
                    className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
                  >
                    Login
                  </button>
                  <button
                    onClick={() => navigate("/signup")}
                    className="px-3 py-1 rounded-full bg-pink-500 text-white text-sm hover:bg-pink-400"
                  >
                    Register
                  </button>
                </>
              )}
            </div>

            {/* Mobile hamburger */}
            <button
              onClick={() => setIsMobileMenuOpen((s) => !s)}
              className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? "×" : "☰"}
            </button>
          </header>

          {/* Mobile menu content */}
          {isMobileMenuOpen && (
            <div className="md:hidden bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 animate-fadeIn">
              {isLoggedIn ? (
                <div className="flex flex-row items-center justify-center gap-3">
                  <span className="text-pink-300 font-medium whitespace-nowrap h-7">
                    Welcome, {userName}
                  </span>
                  <button
                    onClick={handleLogout}
                    className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                    title="Logout"
                  >
                    ⏻
                  </button>
                </div>
              ) : (
                <div className="flex flex-row items-center justify-center gap-6">
                  <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                    Login
                  </Link>
                  <span className="text-pink-500">|</span>
                  <Link to="/signup" className="text-pink-300 hover:text-yellow-300">
                    Register
                  </Link>
                </div>
              )}
            </div>
          )}

          {/* Main Content */}
          <main className="flex-1 py-8 px-4 text-center">
            <div className="max-w-md mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-pink-400 mb-6">
                Content Income Dashboard
              </h1>
              <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
                You have not started your content income journey yet! Click Explore How My Income Will Look Like button below to see a sample income inf.
              </p>
              <button
                onClick={() => setShowSample(true)}
                className="bg-gradient-to-r from-pink-500 to-pink-600 text-white font-semibold py-3 px-8 rounded-xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition w-full sm:w-auto"
              >
                Explore How My Income Will Look Like
              </button>
            </div>
          </main>

          {/* Footer */}
          <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4 mt-auto">
            <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
              <div className="text-xs lg:text-sm">
                © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
              </div>
              <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
                <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
                <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
                <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
              </div>
            </div>
          </footer>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-pink-100 font-sans">
        {/* Header */}
        <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 flex items-center justify-between shadow-lg">
          <div className="flex flex-col">
            <div className="text-xl lg:text-2xl font-bold text-pink-400">💖 SheEarns Content</div>
            <div className="text-[10px] lg:text-lg text-yellow-200">
              My Content Income
            </div>
          </div>

          {/* Desktop user controls */}
          <div className="hidden md:flex items-center gap-3">
            {isLoggedIn ? (
              <>
                <div className="text-xs text-left text-pink-300">{userName}</div>
                <button
                  onClick={handleLogout}
                  className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                  title="Logout"
                >
                  ⏻
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => navigate("/login")}
                  className="px-3 py-1 rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900"
                >
                  Login
                </button>
                <button
                  onClick={() => navigate("/signup")}
                  className="px-3 py-1 rounded-full bg-pink-500 text-white text-sm hover:bg-pink-400"
                >
                  Register
                </button>
              </>
            )}
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setIsMobileMenuOpen((s) => !s)}
            className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-pink-300 bg-pink-500"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </header>

        {/* Mobile menu content */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#2a0f2f] border-b border-pink-800 px-4 py-2 animate-fadeIn">
            {isLoggedIn ? (
              <div className="flex flex-row items-center justify-center gap-3">
                <span className="text-pink-300 font-medium whitespace-nowrap h-7">
                  Welcome, {userName}
                </span>
                <button
                  onClick={handleLogout}
                  className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                  title="Logout"
                >
                  ⏻
                </button>
              </div>
            ) : (
              <div className="flex flex-row items-center justify-center gap-6">
                <Link to="/login" className="text-pink-300 hover:text-yellow-300">
                  Login
                </Link>
                <span className="text-pink-500">|</span>
                <Link to="/signup" className="text-pink-300 hover:text-yellow-300">
                  Register
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Main Content */}
        <main className="flex-1 py-6 px-4">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-bold text-pink-400 mb-6 text-center">
              Sample Content Income Records for {fromDate} to {toDate} | Content: {selectedContent}
            </h1>

            {/* Filters */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              <select
                value={selectedContent}
                onChange={(e) => setSelectedContent(e.target.value)}
                className="bg-gray-800 text-pink-100 px-3 py-2 h-10 rounded-lg border border-pink-500 focus:outline-none focus:border-pink-400"
              >
                {contentTitles.map((title) => (
                  <option key={title} value={title}>{title}</option>
                ))}
              </select>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="bg-gray-800 text-pink-100 px-3 py-2 rounded-lg border border-pink-500 focus:outline-none focus:border-pink-400"
              />
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="bg-gray-800 text-pink-100 px-3 py-2 rounded-lg border border-pink-500 focus:outline-none focus:border-pink-400"
              />
            </div>

            {/* Totals */}
            <div className="bg-gray-800 rounded-lg p-4 mb-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-center">
                <div>
                  <p className="text-pink-400 font-semibold">Total Records</p>
                  <p className="text-white">{recordCount}</p>
                </div>
                <div>
                  <p className="text-pink-400 font-semibold">Total Income</p>
                  <p className="text-white">₹{totalAmount.toLocaleString()}</p>
                </div>
                <div>
                  <p className="text-pink-400 font-semibold">Date Range</p>
                  <p className="text-white">{fromDate} to {toDate}</p>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-pink-500 bg-gray-800 rounded-lg">
                <thead>
                  <tr className="bg-pink-900">
                    <th className="border border-pink-500 p-3 text-left text-pink-200">SN</th>
                    <th className="border border-pink-500 p-3 text-left text-pink-200">Content Title</th>
                    <th className="border border-pink-500 p-3 text-left text-pink-200">Date</th>
                    <th className="border border-pink-500 p-3 text-left text-pink-200">No. of Views</th>
                    <th className="border border-pink-500 p-3 text-left text-pink-200">Income (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRecords.map((rec) => (
                    <tr key={rec.sn} className="hover:bg-gray-700 transition">
                      <td className="border border-pink-500 p-3">{rec.sn}</td>
                      <td className="border border-pink-500 p-3">{rec.contentTitle}</td>
                      <td className="border border-pink-500 p-3">{rec.date}</td>
                      <td className="border border-pink-500 p-3">{rec.views}</td>
                      <td className="border border-pink-500 p-3 font-semibold text-green-400">₹{rec.income.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#2a0f2f] border-t border-pink-800 text-pink-300 py-4 mt-auto">
          <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-xs lg:text-sm">
              © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
              <Link to="/about-us" className="text-white hover:text-pink-400">About</Link>
              <Link to="/privacy-policy" className="text-white hover:text-pink-400">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white hover:text-pink-400">Terms of Use</Link>
              <Link to="/contact-us" className="text-white hover:text-pink-400">Contact</Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default SheEarnsMyContentWatchIncome;